@if (isLoading$ | async) {
	<section>
		<div class="loading-container coverage flex">
			<bci-spinner [type]="'generico'"></bci-spinner>
			<p class="title text">Estamos verificando los datos</p>
			<p class="subtitle text">Espera un momento.</p>
		</div>
	</section>
}
